import { PASSWORD_REQUIREMENTS_REGEX } from '@constants/user';
import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

export const AccountSecuritySchema = ({ formatMessage }: IntlShape, minPasswordLength: number = 10) =>
    Yup.object({
        current_password: Yup.string().required(
            formatMessage(
                {
                    id: 'schema.errors.required',
                    defaultMessage: '{field} is required',
                },
                { field: formatMessage({ id: 'common.currentPassword', defaultMessage: 'Current password' }) }
            )
        ),
        new_password: Yup.string()
            .required(
                formatMessage(
                    {
                        id: 'schema.errors.required',
                        defaultMessage: '{field} is required',
                    },
                    { field: formatMessage({ id: 'common.newPassword', defaultMessage: 'New password' }) }
                )
            )
            .matches(
                PASSWORD_REQUIREMENTS_REGEX,
                formatMessage({
                    id: 'schema.errors.password.requirements',
                    defaultMessage:
                        'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character',
                })
            )
            .min(minPasswordLength, ({ min }) =>
                formatMessage(
                    {
                        id: 'schema.errors.min',
                        defaultMessage: '{field} must be at least {min} characters long',
                    },
                    { field: formatMessage({ id: 'common.newPassword', defaultMessage: 'New password' }), min }
                )
            ),
        confirm_password: Yup.string()
            .required(
                formatMessage(
                    {
                        id: 'schema.errors.required',
                        defaultMessage: '{field} is required',
                    },
                    { field: formatMessage({ id: 'common.confirmNewPassword', defaultMessage: 'Password confirmation' }) }
                )
            )
            .oneOf(
                [Yup.ref('new_password')],
                formatMessage(
                    {
                        id: 'schema.errors.mismatch',
                        defaultMessage: '{field} do not match',
                    },
                    { field: formatMessage({ id: 'common.confirmNewPassword', defaultMessage: 'Passwords' }) }
                )
            ),
    });
